"use client";

import {useTranslation} from "react-i18next";
import type {MutationProposal} from "@/services/wingman/mutation-proposal";
import type {ToolApprovalStatus} from "@repo/ui/gailgpt/tool-approval-status";
import {useDefaultInboundScript} from "@/hooks/useDefaultInboundScript";
import {ApprovalStatusBanner, approvalVisualState, approvalBannerLabel} from "@repo/ui/gailgpt/approval-status-banner";
import {changedFields} from "./ScriptSnapshotDiff";
import {proposalTitle} from "./proposalIdentity";

export default function ScriptApprovalHeader({proposal, statusKey, status, queued}: {
   proposal: MutationProposal;
   statusKey: string;
   status: ToolApprovalStatus;
   queued: boolean | null;
}) {
   const {t} = useTranslation("ask");
   const direction = proposal.after.direction ?? proposal.before.direction;
   const defaultScript = useDefaultInboundScript(direction === "inbound");
   const isDefault = direction === "inbound" && defaultScript?.toLowerCase() === proposal.targetId.toLowerCase();
   const fields = changedFields(proposal);
   const savedTitle = t(fields.length === 1 && fields[0] === "greeting" ? "toolApproval.scriptReview.greetingUpdated" : "toolApproval.scriptReview.scriptUpdated");
   return <>
      <ApprovalStatusBanner state={approvalVisualState(status, queued)}>
         {t(approvalBannerLabel(status, queued, status === "completed" ? "toolApproval.scriptReview.saved" : statusKey))}
      </ApprovalStatusBanner>
      <div className="flex flex-col gap-1 px-4 py-3.5">
         <h3 className="break-words text-approval-title font-bold leading-5 text-900">{status === "completed" ? savedTitle : proposal.summary}</h3>
         <div className="flex flex-wrap items-center gap-1.5 text-xs leading-approval-meta text-600">
            <span className="min-w-0 [overflow-wrap:anywhere]">{proposalTitle(proposal)}</span>
            {isDefault && <span className="approval-default rounded-full px-2 font-medium">{t("toolApproval.scriptReview.defaultInbound")}</span>}
         </div>
      </div>
   </>;
}
